import Button from './Button';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  addButtonAction?: () => void | undefined;
  additionalCardClasses?: string;
  hr?: boolean;
}

const TextTitleCard: React.FC<Props> = ({
  title,
  subtitle,
  children,
  addButtonAction,
  additionalCardClasses,
  hr = true,
}) => (
  <div
    className={`${'glass-surface w-full'} ${additionalCardClasses}`}
  >
    <div className="flex justify-between">
      {title && <h2 className="text-lg font-semibold text-text-primary">{title}</h2>}
      {addButtonAction && <div className="w-12"><Button variant="secondary" onClick={addButtonAction}>+</Button></div>}
    </div>
    {subtitle && <p className="text-xs text-text-secondary mb-3">{subtitle}</p>}
    {title && hr && <hr className="my-3" />}
    <div className={`flex flex-col text-md ${!hr ? 'mt-5' : ''}`}>{children}</div>
  </div>
);

export default TextTitleCard;
